let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("atgUY")).then(() => parcelRequire('dwm7g'));